import { useLocalStorage } from 'usehooks-ts'

import { Product } from '../types/product';
import { ProductCart } from '../types/cart';

const PRODUCTS_CART_STORAGE_KEY = '__PRODUCTS_CART_STORAGE_KEY__';

export const useCart = () => {
  const [products, setProducts] = useLocalStorage<ProductCart[]>(PRODUCTS_CART_STORAGE_KEY, []);

  const updateProduct = (product: Product, attributes: Partial<ProductCart>) => {
    const productsCart = [...products];
    const productIndex = products.findIndex((p) => p.name === product.name);
    const { quantity, ...selectedProduct } = products[productIndex];

    productsCart.splice(productIndex, 1, {
      ...selectedProduct,
      ...(attributes ?? {}) as ProductCart,
    });

    setProducts(productsCart);
  };

  const addProduct = (product: ProductCart) => {
    const addedProducts = [...products, product];

    setProducts(addedProducts);
  };

  const removeProduct = (product: Product) => {
    const productIndex = products.findIndex(p => p.name === product.name);
    const addedProducts = [...products];

    addedProducts.splice(productIndex, 1);

    setProducts(addedProducts);
  };

  const decrementProduct = (product: ProductCart) => {
    const p = product as unknown as Product;

    if (
      (p.countable && product.quantity <= 1) ||
      (!p.countable && product.quantity <= 0.1)
    ) {
      removeProduct(product as unknown as Product);

      return;
    }

    const quantityValue = p.countable ? 1 : 0.1;
    const quantity = (product.quantity - quantityValue).toFixed(2);

    updateProduct(product as unknown as Product, {
      quantity: Number(quantity),
    });
  };

  const incrementProduct = (product: ProductCart) => {
    const p = product as unknown as Product;
    const quantityValue = p.countable ? 1 : 0.1;
    const quantity = (product.quantity + quantityValue).toFixed(2);

    updateProduct(product as unknown as Product, {
      quantity: Number(quantity)
    });
  };

  const alreadyAdded = (product: Product) => {
    return products.some(p => p.name === product.name);
  };

  const getTotal = () => {
    const totalPrice = products.reduce((total, product) => {
      return total + (product.quantity * product.price);
    }, 0);

    return totalPrice.toFixed(2);
  };

  const resetCart = () => {
    setProducts([]);
  };

  return {
    getTotal,
    resetCart,
    products,
    addProduct,
    removeProduct,
    alreadyAdded,
    decrementProduct,
    incrementProduct,
    count: products.length,
  };
};
